import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {useHistory, useRouteMatch} from 'react-router-dom';
import {shallowEqual, useSelector} from 'react-redux';
import {pathnames as P} from '../../../../common/constants/pathnames';
import styles from './styles.module.scss';

const ButtonsSubmitCancelView = ({
                                   prevPagePath,
                                   nextPagePath,
                                 }) => {
  const currentUserID = useSelector(state => state.user.userId, shallowEqual);
  const responsibleUserID = useSelector(state => state.stepStatus.stepStatus.userID, shallowEqual);
  const {params: {formId}} = useRouteMatch(P.INSPECTION_AND_FORM_IDS);

  const history = useHistory();
  const handleGoToPrevPage = () => {
    const path = ((currentUserID !== responsibleUserID) && (formId === '11'))
      ? '3'
      : prevPagePath;
    history.push(path);
    window.scrollTo(0, 0);
  };
  const handleGoToNextPage = () => {
    const path = ((currentUserID !== responsibleUserID) && (formId === '3'))
      ? '11'
      : nextPagePath;
    history.push(path);
    window.scrollTo(0, 0);
  };

  const isBackButtonDisabled = () => {
    return (currentUserID !== responsibleUserID) && (formId === '3');
  };

  return (
    <div className={styles.buttonsSubmitCancelContainer}>
      <div className={classnames(
        styles.buttonsSubmitCancel,
        {[styles.containerWidth]: prevPagePath && nextPagePath}
      )}
      >
        {Boolean(prevPagePath) && (
          <button
            type="button"
            className={styles.buttonCancel}
            onClick={handleGoToPrevPage}
            disabled={isBackButtonDisabled()}
          >
            <span>חזור</span>
          </button>
        )}
        {Boolean(nextPagePath) && (
          <button
            type="submit"
            className={styles.buttonSubmit}
            onClick={handleGoToNextPage}
          >
            <span>המשך</span>
          </button>
        )}
      </div>
    </div>
  );
};

ButtonsSubmitCancelView.propTypes = {
  prevPagePath: PropTypes.string,
  nextPagePath: PropTypes.string,
  hideCancelButton: PropTypes.bool,
  hideSubmitButton: PropTypes.bool,
};

export default ButtonsSubmitCancelView;
